import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
// import pl from './locales/pl/translation.js';
// import en from './locales/en/translation.js';
import Backend from 'i18next-http-backend';

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'pl',
    ns: ['translation'],
    defaultNS: 'translation',
    returnEmptyString: false,
    interpolation: {
      escapeValue: false,
    },
    retryTimeout: 350,
    maxRetries: 5,
    supportedLngs: ['pl', 'en'],
    nonExplicitSupportedLngs: true,
    load: 'languageOnly',
    cleanCode: true,
    backend: {
      loadPath: `${process.env.REACT_APP_TRANSLATIONS_URL}/{{lng}}`,
    },
    /* 
    resources: {
      en: {
        translation: en,
      },
      pl: {
        translation: pl,
      },
    }, */
  });

i18n.on('languageChanged', lng => {
  document.documentElement.lang = lng;
});

export default i18n;
